import axios from "axios"
import {apiCall} from "../../common/apiActionHandler";

export const load = (callback) => (dispatch, getState) => {
    const config = {
        url: `/api/search/all_employees?disabled=true`
    };

    apiCall("Loading data", config, async config => {
        const response = await axios.request(config);
        callback({salesArborists: response.data});
    }, dispatch, getState, false);
};

export const fetchMyProposals = (filter, callback) => async (dispatch, getState) => {
    const config = {
        url: `/api/proposals/my_proposals`,
        params: filter
    };

    apiCall("Getting proposed services", config, async config => {
        const response = await axios.request(config);
        callback(response.data);
    }, dispatch, getState);
};
export const fetchMyProposalsStats = (filter, callback) => async (dispatch, getState) => {
    const config = {
        url: `/api/proposals/my_proposals_stats`,
        params: filter
    };

    apiCall("Getting proposed services stats", config, async config => {
        const response = await axios.request(config);
        callback(response.data);
    }, dispatch, getState);
};
